export const environment = {
  production: false,
  apiUrl: 'https://api-dev.eastindonesiatrip.com',
  assetUrl: 'https://eastindonesiatrip.com/assets/img',
  apiKey: 'api_live_92f03dd1b7e64b5fa0a1b79c4eaf1234', // ⬅️ Tambahkan ini
  googleClientId:
    '866671432525-q7u3e6nakdh1r8jq0rflae7cb2m80sff.apps.googleusercontent.com',
  contentSecurityPolicy: {
    'script-src': [
      "'self'",
      'https://apis.google.com',
      'https://www.gstatic.com',
      "'unsafe-inline'",
      "'unsafe-eval'",
    ],
  },
  recaptchaSiteKey: '6LfBoBIrAAAAAJI1M1f3fEt7SfQVRAQv56ytbXbl',
  recaptchaSecretKey: '6LfBoBIrAAAAAJ48GqLLGnYYQMBnCjAvoJQuDwz0',
};
